/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import * as z from "zod";

export const getJsonValidator = (validator: any) => {
  const literalSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
  ]);
  type Literal = z.infer<typeof literalSchema>;
  type Json = Literal | { [key: string]: Json } | Json[];
  const jsonSchema: z.ZodType<Json> = z.lazy(() =>
    z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)])
  );

  let newz = z.string();
  if (validator) {
    validator.forEach((rule: any) => {
      if (rule) {
        if (rule.rule === "regex") {
          newz = newz.regex(
            new RegExp(rule.condition as unknown as string),
            rule?.message ?? "The input must satisfy regex expression"
          );
        }
        if (rule.rule === "maxLength") {
          const maxLength = rule.condition as unknown as string;
          newz = newz.max(
            +maxLength,
            rule?.message ??
              `The maximum length of input should be ${maxLength} characters`
          );
        }
        if (rule.rule === "notAllowedWords") {
          let disallowedWords = (rule.condition as unknown as string)
            .split(",")
            .map((s) => s.trim())
            .join("|");

          let regex = new RegExp("^(?!.*?(" + disallowedWords + ")).*?$", "is");

          newz = newz.regex(
            regex,
            rule?.message ??
              `The input must not contain ${disallowedWords
                .split("|")
                .join(",")}`
          );
        }
      }
    });
  }
  return newz
    .transform((data, ctx) => {
      try {
        return JSON.parse(data);
      } catch (e) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "The input is not a valid JSON",
        });
      }
    })
    .pipe(jsonSchema);
};
